import { useMemo } from 'react';

import { useGetInboxEntryTree } from '../../services/inboxEntryTree.service';
import { buildTaskTree } from '../../utils/taskTree/buildTaskTree';

export function useInboxEntryTree(rootInboxEntryId: string | undefined) {
  const { entries, loading, error, refetch } =
    useGetInboxEntryTree(rootInboxEntryId);

  const tree = useMemo(
    () =>
      entries && rootInboxEntryId
        ? buildTaskTree(entries, rootInboxEntryId)
        : null,
    [entries, rootInboxEntryId],
  );

  return {
    tree,
    isLoading: loading && !entries,
    hasLoadFailed: Boolean(error) && !entries,
    isNotFound: Boolean(entries) && !tree,
    refetch,
  };
}
